import React from 'react';

import AuditStateMessage from 'app/shared/modules/EntityAuditHistory/components/AuditStateMessage';
import {
  DETAIL_RETRY_LABEL,
  DETAIL_UNAVAILABLE_MESSAGE,
} from 'app/shared/modules/EntityAuditHistory/EntityAuditHistory.constants';
import PropTypes from 'prop-types';

import {
  FILE_FACTS_UNAVAILABLE_MESSAGE,
  TEMPLATE_LOAD_FAILED_MESSAGE,
  TEMPLATE_LOADING_LABEL,
  TemplateRequestStatus,
} from '../../FormChangeHistory.constants';
import { FormChangeHistoryTestIds } from '../../FormChangeHistory.testIds';

/**
 * A template read that has not answered with data: nothing to read on either side, an answer about
 * another kind of template, still loading, unavailable for good (404 / 410), or failed with a retry.
 */
const TemplateRequestState = ({
  status,
  onRetry,
  emptyLabel = null,
  loadingLabel = TEMPLATE_LOADING_LABEL,
  failedMessage = TEMPLATE_LOAD_FAILED_MESSAGE,
}) => {
  if (status === TemplateRequestStatus.EMPTY) {
    return (
      <AuditStateMessage
        dataTestId={FormChangeHistoryTestIds.NO_TEMPLATE_VALUE}
        isFramed={false}
        message={emptyLabel}
      />
    );
  }

  if (status === TemplateRequestStatus.OTHER_KIND) {
    return (
      <AuditStateMessage
        dataTestId={FormChangeHistoryTestIds.TEMPLATE_STATE}
        isFramed={false}
        message={FILE_FACTS_UNAVAILABLE_MESSAGE}
      />
    );
  }

  if (status === TemplateRequestStatus.LOADING) {
    return (
      <AuditStateMessage
        isLoading
        dataTestId={FormChangeHistoryTestIds.TEMPLATE_STATE}
        isFramed={false}
        message={loadingLabel}
      />
    );
  }

  if (status === TemplateRequestStatus.UNAVAILABLE) {
    return (
      <AuditStateMessage
        dataTestId={FormChangeHistoryTestIds.TEMPLATE_STATE}
        isFramed={false}
        message={DETAIL_UNAVAILABLE_MESSAGE}
      />
    );
  }

  return (
    <AuditStateMessage
      dataTestId={FormChangeHistoryTestIds.TEMPLATE_STATE}
      isFramed={false}
      message={failedMessage}
      retryLabel={DETAIL_RETRY_LABEL}
      retryTestId={FormChangeHistoryTestIds.TEMPLATE_RETRY_BUTTON}
      onRetry={onRetry}
    />
  );
};

TemplateRequestState.propTypes = {
  status: PropTypes.string.isRequired,
  onRetry: PropTypes.func.isRequired,
  emptyLabel: PropTypes.string,
  loadingLabel: PropTypes.string,
  failedMessage: PropTypes.string,
};

export default TemplateRequestState;
